<template>
    <v-dialog v-model="dialog" width="600" :fullscreen="isMobileOrTablet()" persistent>
        <v-card class="rounded-lg" style="display: flex; flex-direction: column; height: 100%;">
            <v-card-title style="background-color: #1a5b0f !important; display: flex; justify-content: space-between; align-items: center;">
                <div>
                    <span class="font-weight-bold text-h6 text-white">{{ dialog_title }}</span>
                    <div class="text-caption text-white">{{ dialog_sub_title }}</div>
                </div>
                <v-btn v-if="loading == false" flat icon color="darkGreen" @click="closeDialog()">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text style="overflow-y: auto; max-height: calc(100vh - 100px);">
                <v-form ref="form" class="mt-2">
                    <v-row dense>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="faculty"
                                :rules="[formRules.required]"
                                label="Faculty Name"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                :items="facultyData"
                                :item-title="getItemTitle"
                                item-value="id"
                                return-object
                                >
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12">
                            <v-date-input
                                v-model="mentoring_date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                :rules="[formRules.required]"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                label="Mentoring Date"
                            ></v-date-input>
                        </v-col>
                        <v-col cols="12">
                            <v-date-input
                                v-model="closeout_date"
                                prepend-icon=""
                                prepend-inner-icon="mdi-calendar"
                                variant="outlined"
                                rounded="lg"
                                type="text"
                                color="darkGreen"
                                label="Close-out Date"
                                clearable
                            ></v-date-input>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="pa-3" style="margin-top: auto;">
                <v-spacer></v-spacer>
                <v-btn class="mr-1" :disabled="loading" text="Cancel" variant="outlined" elevation="1" @click="closeDialog()"></v-btn>
                <v-btn class="mr-1" :loading="loading" text="Save" variant="elevated" elevation="1" color="darkGreen" @click="validateForm()"></v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <ViewFileDialog ref="ViewFileDialog" />
</template>

<script>
import { defineComponent } from 'vue'
import { useSnackbar } from '@/composables/useSnackbar'
import ViewFileDialog from './Sub-Dialogs/ViewFileDialog.vue';

export default defineComponent({
     emits: ["refresh"],
     components: {
        ViewFileDialog
     },
     data(){
        return {
            dialog: false,
            dialog_title: null,
            dialog_sub_title: null,
            action: null,
            loading: false,

            id: null,
            faculty_id: null,
            mentoring_date: null,
            closeout_date: null,
            office_id: null,
            semester_schoolyear_id: null,
            facultyData: [],
            faculty: null,
        }
     },
     methods: {
        initAdd(){
            this.dialog = true
            this.dialog_title = 'Add Mentoring'
            this.dialog_sub_title = 'Add new mentoring information'
            this.action = 'add'

            this.semester_schoolyear_id = this.$store.state.semester_schoolyear.id
            this.office_id = this.$store.state.user.office.id
            this.initFaculties()
        },
        initUpdate(data){
            this.dialog = true
            this.dialog_title = 'Update Mentoring'
            this.dialog_sub_title = 'Update mentoring information'
            this.action = 'edit'

            this.id = data.id
            this.faculty = data.faculty
            this.mentoring_date = data.mentoring_date
            this.closeout_date = data.closeout_date
            this.initFaculties()
        },
        async initFaculties(){
            let res = await this.axiosCall('/user-details/findAllWithProgramByInstituteWithoutMentoring/' + this.$store.state.user.office.id + '/' + this.$store.state.semester_schoolyear.id, 'get', null, true)
            if(res.data){
                this.facultyData = res.data

                if (this.action === 'add') {
                    const currentFaculty = this.facultyData.find((item) => item.id === this.$store.state.user.id)
                    if (currentFaculty) {
                        this.faculty = currentFaculty
                    }
                }
            }
        },
        getItemTitle(item) {
            return `${item.fname} ${item.mname ? item.mname[0] + '.' :''} ${item.lname}${item.suffix ? ', ' + item.suffix : ''}` ;
        },
        async validateForm(){
            const { showSnackbar } = useSnackbar()
            const { valid } = await this.$refs.form.validate()

            if(valid){
                this.loading = true
                const formData = new FormData();
                formData.append('id', this.id || '');
                formData.append('faculty_id', this.faculty.id);
                formData.append('mentoring_date', this.mentoring_date);
                formData.append('closeout_date', this.closeout_date ?? '');
                formData.append('office_id', this.office_id);
                formData.append('semester_schoolyear_id', this.semester_schoolyear_id);
                formData.append('notif_from', this.$store.state.user.id);

                if(this.action == 'add'){
                    let res = await this.axiosCall('/mentoring', 'post', formData, true)
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Mentoring successfully added!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
                else if(this.action == 'edit'){
                    let res = await this.axiosCall('/mentoring/' + this.id, 'patch', formData, true)
                    if(res.data.status == 200){
                        this.loading = false
                        this.$emit('refresh')
                        showSnackbar('Mentoring successfully updated!')
                        this.$refs.form.reset()
                        this.dialog = false
                    }
                }
            }
        },
        closeDialog(){
            this.$refs.form.reset()
            this.$emit('refresh')
            this.dialog = false
        }
     }
})
</script>

<style scoped>

</style>